<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ch00_fm08"><a id="page_13"></a><strong>Publisher’s Note</strong></h2>
<p class="indent">At the time it was written, all information in this book was believed by the author to be correct and factual. Information on celiac disease and gluten-free food changes frequently, as research is ongoing. Always keep yourself up-to-date by reading current, reputable publications and continuing to check food ingredient lists. The author and the publisher disclaim any liability arising directly or indirectly from the use of this book. The author will not accept any responsibility for any omissions, misinterpretations, or misstatements that may exist within this book. The author does not endorse any product or company listed in this book. The author is not engaged in rendering medical services and this book should not be construed as medical advice, nor should it take the place of regular scheduled appointments with your physician and/or dietitian. Please, consult your healthcare professional for medical advice.<a id="page_14"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm08.vue?1e45fe9a